export const Paths = {
    index: (portalId: string) => `/${portalId}`,
    cases: '/cases',
    viewEditCase: (caseId: string) => {
        return `/case/${caseId}`;
    },
    templates: '/templates',
    accountSettings: '/account/settings',
    clientsParties: '/account/clientsParties',
    insights: '/insights',
}